import { Form } from "react-bootstrap";

const SelectTpCategoriaFormik = ({ formik, field }) => {
  const categorias = [
    {
      tpCategoria: "LF",
      nomeCategoria: "Livros Fiscais",
    },
    {
      tpCategoria: "NF",
      nomeCategoria: "Notas Fiscais e/ou equivalentes",
    },
    {
      tpCategoria: "DI",
      nomeCategoria: "Outros Documentos",
    },
  ];

  return (
    <>
      <Form.Control
        as="select"
        id={field}
        name={field}
        disabled={formik.isSubmitting}
        value={formik.values[field]}
        onChange={formik.handleChange}
        isInvalid={formik.touched[field] && formik.errors[field]}
      >
        <option key="" value="">
          Selecione
        </option>
        {categorias.map((item) => (
          <option key={item.tpCategoria} value={item.tpCategoria}>
            {item.nomeCategoria}
          </option>
        ))}
      </Form.Control>
      {formik.touched[field] && formik.errors[field] && (
        <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
      )}
    </>
  );
};

export default SelectTpCategoriaFormik;
